import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import { useEmployeeAuth } from "./auth/EmployeeAuthContext";
import { EmployeeDataProvider } from "./context/EmployeeDataContext";

import ProtectedEmployeeRoute from "./routes/ProtectedEmployeeRoute";
import EmployeeLogin from "./pages/EmployeeLogin";
import EmployeeDashboard from "./pages/EmployeeDashboard";
import EmployeeTasks from "./pages/EmployeeTasks";
import EmployeeCalendar from "./pages/EmployeeCalendar";
import EmployeePayroll from "./pages/EmployeePayroll";
import EmployeeProfile from "./pages/EmployeeProfile";
import EmployeeLeaves from "./pages/EmployeeLeaves";

import HrDashboard from "./pages/HrDashboard";
import HrAssignTasks from "./pages/HrAssignTasks";
import HrPayouts from "./pages/HrPayouts";
import HrManageEmployees from "./pages/HrManageEmployees";
import HrLeaves from "./pages/HrLeaves";
import CalendarPage from "./pages/CalendarPage";
import DynamicAppTracking from "./pages/tech/DynamicAppTracking";


const EmployeeRoutes = () => {
  const { isAuthenticated, user } = useEmployeeAuth();

  // If not logged in, allow only login route
  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="login" element={<EmployeeLogin />} />
        <Route path="*" element={<Navigate to="/employee/login" replace />} />
      </Routes>
    );
  }

  // Logged in: show HR or Employee routes based on role
  return (
    <Routes>
      <Route element={<ProtectedEmployeeRoute />}>
        <Route element={<EmployeeDataProvider><Outlet /></EmployeeDataProvider>}>
          {/* Tech Dashboard Routes - Accessible to all authorized employees/HR for now */}
          <Route path="tech/:appId" element={<DynamicAppTracking />} />

          {user?.role === "hr" && (
            <>
              <Route path="hr-dashboard" element={<HrDashboard />} />
              <Route path="hr-manage-employees" element={<HrManageEmployees />} />
              <Route path="hr-payouts" element={<HrPayouts />} />
              <Route path="hr-assign-tasks" element={<HrAssignTasks />} />
              <Route path="calendar-page" element={<CalendarPage />} />
              <Route path="hr-leaves" element={<HrLeaves />} />
              <Route path="leaves/:email" element={<EmployeeLeaves />} />
              <Route path="payroll/:email" element={<EmployeePayroll />} />
            </>
          )}

          <Route path="dashboard" element={<EmployeeDashboard />}>
            <Route index element={<Navigate to={user?.role === "hr" ? "/employee/hr-dashboard" : "tasks"} replace />} />
            <Route path="tasks" element={<EmployeeTasks />} />
            <Route path="payroll" element={<EmployeePayroll />} />
            <Route path="calendar" element={<EmployeeCalendar />} />
            <Route path="leaves" element={<EmployeeLeaves />} />
            <Route path="profile" element={<EmployeeProfile />} />
            <Route path="tech/:appId" element={<DynamicAppTracking />} />
          </Route>

          <Route index element={<Navigate to={user?.role === "hr" ? "/employee/hr-dashboard" : "/employee/dashboard/tasks"} replace />} />
          <Route
            path="*"
            element={
              <Navigate
                to={
                  user?.role === "hr"
                    ? "/employee/hr-dashboard"
                    : "/employee/dashboard/tasks"
                }
                replace
              />
            }
          />
        </Route>
      </Route>
    </Routes>
  );
}

export default EmployeeRoutes;
